import de from '@translations/de/uploadCSVPopup.json';
import en from '@translations/en/uploadCSVPopup.json';
import pl from '@translations/pl/uploadCSVPopup.json';
import sl from '@translations/sl/uploadCSVPopup.json';
import uk from '@translations/uk/uploadCSVPopup.json';
import bg from '@translations/bg/uploadCSVPopup.json';
import cz from '@translations/cz/uploadCSVPopup.json';
import fr from '@translations/fr/uploadCSVPopup.json';
import gr from '@translations/gr/uploadCSVPopup.json';
import it from '@translations/it/uploadCSVPopup.json';
import pr from '@translations/pr/uploadCSVPopup.json';
import ru from '@translations/ru/uploadCSVPopup.json';
import sk from '@translations/sk/uploadCSVPopup.json';
import sp from '@translations/sp/uploadCSVPopup.json';
import tr from '@translations/tr/uploadCSVPopup.json';
import hu from '@translations/hu/uploadCSVPopup.json';
import { ITranslations } from '@/types/common';
import { UploadCSVPopupTransFields } from './types';

export const uploadCSVPopupTranslations: ITranslations<UploadCSVPopupTransFields> = {
  name: 'uploadCSVPopup',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
